import { CHART_COLORS, PALETTE, BG_PALETTE } from "../lib/theme";
import type { Section1 } from "../lib/types";

interface Props {
  data: Section1;
}

// Renders the "Fondamentaux du local" panel: metric rows + qualitative criteria.
// "Non renseigné" rows are filtered out so the panel stays compact.
export function SectionFundamentals({ data }: Props) {
  const m = data.metriques ?? ({} as Section1["metriques"]);

  const metRows = [
    { critere: "Surface",         valeur: m.surface },
    { critere: "Vitrine",         valeur: m.vitrine },
    { critere: "Trottoir",        valeur: m.trottoir },
    { critere: "Parking devant",  valeur: m.parkingDevant },
    { critere: "Parking à 200 m", valeur: m.parking200m },
  ].filter((r) => r.valeur && r.valeur !== "Non renseigné");

  const donneeRows = (data.donnees ?? []).filter(
    (d) =>
      d.valeur &&
      d.valeur !== "Non renseigné" &&
      !metRows.some(
        (mr) => mr.critere.toLowerCase() === d.critere.toLowerCase(),
      ),
  );

  const allRows = [...metRows, ...donneeRows];

  return (
    <div
      className="flex flex-col gap-0.5 overflow-hidden rounded-2xl"
      style={{ border: `1.5px solid ${PALETTE[0]}22` }}
    >
      <div className="px-3.5 pt-2.5 pb-2" style={{ background: BG_PALETTE[0] }}>
        <div
          className="text-[10px] font-bold uppercase tracking-widest"
          style={{ color: PALETTE[0] }}
        >
          Métriques du local
        </div>
      </div>
      {allRows.map((row, i) => {
        const c = CHART_COLORS[i % CHART_COLORS.length];
        return (
          <div
            key={`${row.critere}-${i}`}
            className="flex items-start justify-between gap-3 border-t border-slate-100 px-3.5 py-3"
            style={{
              background: i % 2 === 0 ? "#fff" : "#fafafa",
              borderLeft: `3px solid ${c}`,
            }}
          >
            <div className="flex items-center gap-2">
              <span
                className="block h-2 w-2 shrink-0 rounded-full"
                style={{ background: c }}
              />
              <span className="text-sm font-semibold" style={{ color: c }}>
                {row.critere}
              </span>
            </div>
            <div className="text-right text-sm font-semibold leading-tight text-slate-900">
              {row.valeur}
            </div>
          </div>
        );
      })}
    </div>
  );
}
